import { AutogenLayoutlayout_diwfalias } from "./autogen/AutogenLayoutlayout_diwfalias";
import {  DataSourceExecutionEvent } from "@mcleod/components";
import { DropdownItem, Textbox } from "@mcleod/components";

export class layout_diwfalias extends AutogenLayoutlayout_diwfalias {

/** This is an event handler for the afterExecution event of sourceImgApps. */
  sourceImgAppsAfterExecution(event: DataSourceExecutionEvent) {
    if( this.textboxDiwfaAppid.items )
        return;
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    let appid = null;
    for (const row of rows) {
        //console.log("Row: ", row );
        if( appid != row._data.imap_appid )
        {
            appid = row._data.imap_appid;
            let appname = row._data.imap_appname;
            appname = appname.replace("&","");
            //items.push({ caption: appid + " - " + appname, value: appid });
            items.push(new DropdownItem(appid, appid + " - " + appname));
        }
    }
    this.textboxDiwfaAppid.items = items;
  }

/** This is an event handler for the afterExecution event of sourceDidbalias. */
  sourceDidbaliasAfterExecution(event: DataSourceExecutionEvent) {
    if( this.textboxDiwfaDbalias.items )
        return;
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    let dbalias = null;
    for (const row of rows) {
        //console.log("Row: ", row );
        if( dbalias != row._data.didb_dbalias )
        {
            dbalias = row._data.didb_dbalias;
            let desc = row._data.didb_desc;
            desc = desc.replace("&","");
            //items.push({ caption: dbalias + " - "+ desc, value: dbalias });
            items.push(new DropdownItem(dbalias, dbalias + " - "+ desc));
        }
    }
    this.textboxDiwfaDbalias.items = items;
  }
}
